
import React from 'react';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';

const PoliticaPrivacidade = () => {
  return (
    <div className="min-h-screen">
      <section className="pt-16 pb-6 bg-gradient-to-b from-blue-50/50 to-transparent">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="max-w-4xl mx-auto"
          >
            <div className="flex items-center gap-3 mb-6 justify-center md:justify-start">
              <div className="bg-blue-light/20 p-2 rounded-full">
                <Lock className="h-6 w-6 text-blue-dark" />
              </div>
              <h1 className="text-3xl md:text-4xl font-bold text-blue-dark">Política de Privacidade</h1>
            </div>
            <div className="bg-white rounded-lg shadow-md p-6 md:p-8 mb-8">
              <p className="text-gray-600 mb-6">
                Última atualização: 01/04/2025
              </p>

              <div className="space-y-6">
                <section>
                  <h2 className="text-xl font-semibold text-blue-dark mb-3">1. Introdução</h2>
                  <p className="text-gray-700 mb-3">
                    No BrokerBase, valorizamos sua privacidade e estamos comprometidos em proteger seus dados pessoais. Esta Política de Privacidade explica como coletamos, usamos, processamos e armazenamos suas informações quando você utiliza nossa plataforma.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-blue-dark mb-3">2. Informações que Coletamos</h2>
                  <p className="text-gray-700 mb-3">
                    Podemos coletar diferentes tipos de informações, incluindo:
                  </p>
                  <ul className="list-disc pl-5 text-gray-700 space-y-1">
                    <li>Informações pessoais (nome, e-mail, telefone)</li>
                    <li>Dados de uso da plataforma e interações</li>
                    <li>Informações técnicas do seu dispositivo e conexão</li>
                    <li>Cookies e tecnologias semelhantes</li>
                    <li>Informações fornecidas ao realizar consultas de imóveis</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-blue-dark mb-3">3. Como Usamos suas Informações</h2>
                  <p className="text-gray-700 mb-3">
                    Utilizamos suas informações para:
                  </p>
                  <ul className="list-disc pl-5 text-gray-700 space-y-1">
                    <li>Fornecer e melhorar nossos serviços</li>
                    <li>Processar análises imobiliárias solicitadas</li>
                    <li>Personalizar sua experiência na plataforma</li>
                    <li>Comunicar-nos com você sobre atualizações e ofertas</li>
                    <li>Cumprir obrigações legais e proteger nossos direitos</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-blue-dark mb-3">4. Compartilhamento de Dados</h2>
                  <p className="text-gray-700 mb-3">
                    Podemos compartilhar suas informações com:
                  </p>
                  <ul className="list-disc pl-5 text-gray-700 space-y-1">
                    <li>Prestadores de serviços que nos auxiliam na operação da plataforma</li>
                    <li>Parceiros comerciais, com seu consentimento prévio</li>
                    <li>Autoridades competentes, quando exigido por lei</li>
                  </ul>
                  <p className="text-gray-700 mt-3">
                    Não vendemos ou alugamos suas informações pessoais a terceiros para fins de marketing.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-blue-dark mb-3">5. Segurança de Dados</h2>
                  <p className="text-gray-700 mb-3">
                    Implementamos medidas de segurança técnicas e organizacionais para proteger suas informações contra acesso não autorizado, alteração, divulgação ou destruição.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-blue-dark mb-3">6. Seus Direitos</h2>
                  <p className="text-gray-700 mb-3">
                    De acordo com a Lei Geral de Proteção de Dados (LGPD), você tem direitos sobre seus dados pessoais, incluindo:
                  </p>
                  <ul className="list-disc pl-5 text-gray-700 space-y-1">
                    <li>Acesso às suas informações pessoais</li>
                    <li>Correção de dados incompletos ou incorretos</li>
                    <li>Exclusão de seus dados, em determinadas circunstâncias</li>
                    <li>Restrição ou oposição ao processamento de seus dados</li>
                    <li>Portabilidade de dados para outro serviço</li>
                  </ul>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-blue-dark mb-3">7. Cookies e Tecnologias Semelhantes</h2>
                  <p className="text-gray-700 mb-3">
                    Utilizamos cookies e tecnologias semelhantes para melhorar sua experiência, entender como você utiliza nossos serviços e personalizar nosso conteúdo.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-blue-dark mb-3">8. Alterações na Política de Privacidade</h2>
                  <p className="text-gray-700 mb-3">
                    Podemos atualizar esta política periodicamente. Notificaremos você sobre quaisquer alterações significativas através de um aviso em nosso site ou por e-mail.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-blue-dark mb-3">9. Retenção de Dados</h2>
                  <p className="text-gray-700 mb-3">
                    Mantemos suas informações pessoais pelo tempo necessário para cumprir os propósitos descritos nesta política, a menos que um período de retenção mais longo seja exigido ou permitido por lei.
                  </p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold text-blue-dark mb-3">10. Contato</h2>
                  <p className="text-gray-700 mb-3">
                    Se você tiver dúvidas ou preocupações sobre nossa Política de Privacidade ou práticas de dados, entre em contato conosco através do email disponível em nossa plataforma.
                  </p>
                </section>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default PoliticaPrivacidade;
